module.exports = __webpack_public_path__ + "img/banner1.33896a51.jpg";